// Models
// Utilities
import { Temporal } from "temporal-polyfill-lite";
/** Class to handle serialization/deserialization for status tables*/ export class StoreEntityStatusSerializationHandler {
    /** serialize to IStoreEntityStatusPersistedResource */ toSerializable(key, value) {
        return {
            key: key,
            deltaLink: value.deltaSyncState?.link,
            state: value.state,
            timestamp: value.timestamp?.toString()
        };
    }
    /** build StoreEntityStatus from IStoreEntityStatusPersistedResource */ fromSerializable(key, serializableValue) {
        const status = {
            state: serializableValue.state,
            isFetching: false,
            deltaSyncState: serializableValue.deltaLink ? {
                link: serializableValue.deltaLink,
                backoffErrorStreak: 0,
                emptyStreak: 0
            } : undefined,
            timestamp: serializableValue.timestamp ? Temporal.Instant.from(serializableValue.timestamp) : null
        };
        return status;
    }
}
